import Invoice from 'model/Invoice'

export default class rollDetailCtrl {
    constructor($scope, httpRequest, $state, $stateParams, $timeout) {
        $scope.isDetail = true
        // 隐藏一二级菜单
        $('#wrapper').addClass('invoiceDetailPage')
        $scope.$on('$stateChangeStart', () => {
            $('#wrapper').removeClass('invoiceDetailPage')
        })

        // 如果是已开发票详情
        if ($state.current.name.indexOf('openedInvoice.rollDetail') > -1) {
            $scope.showBillCode = true
        }
        $scope.init = async function init() {
            $scope.invoice = new Invoice()
            if ($stateParams.invoiceId) {
                const { invoiceId } = $stateParams
                const invoiceRes = await httpRequest.post_getOvatInvoice(invoiceId)
                $scope.invoice = new Invoice(invoiceRes.data.value)
                // $scope.rollticketCode = JSON.parse($scope.invoice.extendInfo).rollticketCode
            } else {
                $scope.invoice = new Invoice()
                const waitIdRes = await httpRequest.get_getBeanId_dkfp()
                $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                $scope.invoice.invType = $stateParams.invType
                $scope.invoice.invoiceDate = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 00:00:00`
                if ($state.current.name == 'outputManage.FOManage.invoice.rollTypeInvoiceRedAdd') {
                    $scope.isRed = true
                    $scope.invoice.$isRed = '1'
                }
            }
            const typecodeArr = ['zero_tax']
            $scope.dictionary = {}
            $scope.specList = []
            const disctDataRes = await httpRequest.get_dictByTypeArr(JSON.stringify(typecodeArr))
            Object.assign($scope.dictionary, disctDataRes.data.value)
            $scope.invoice.blueInvoiceCode = ''
            $scope.invoice.blueInvoiceNumber = ''

            $scope.invoice.details.forEach((item) => {
                item.goodsObject = { shortAndMatName: item.shortAndMatName }
            })
            // 初始化buyer对象
            $timeout(() => {
                $scope.buyer = $scope.invoice.customer
                $scope.buyer.customerName = $scope.buyer.custName
                $scope.buyer.creditCode = $scope.buyer.custCreditCode
                $scope.version = $scope.invoice.details[0].revenueVersion
            })
            // 初始化发票类型为卷票
            $scope.invoice.invType = '41'
            // $scope.changerUkeyId()
        }
        $scope.init()
        $scope.selectedRows = []
    }
}
rollDetailCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', '$timeout']



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/cancelInvoice/rollDetailCtrl.js